import { api } from "../client";
import {
  BasketExtraFields,
  BasketFields,
  PartialBasketExtraFields,
  PartialBasketFields,
} from "../schema/Basket";
import { Config, ConfigMutate } from "../types";

type ApiRequestConfig = Config<BasketFields, BasketExtraFields>;
type ApiRequestConfigMutate = ConfigMutate<
  PartialBasketFields,
  PartialBasketExtraFields
>;

export const getBaskets = async (config?: ApiRequestConfig) => {
  return api.get<BasketFields, BasketExtraFields>("baskets", config);
};
export const getBasket = (id: number, config?: ApiRequestConfig) => {
  return api.get<BasketFields, BasketExtraFields>(`baskets/${id}`, config);
};

export const createBasket = (config: ApiRequestConfigMutate) => {
  return api.create<PartialBasketFields, PartialBasketExtraFields>(
    "baskets",
    config
  );
};
export const updateBasket = (id: number, config?: ApiRequestConfigMutate) => {
  return api.update<PartialBasketFields, PartialBasketExtraFields>(
    `baskets/${id}`,
    config
  );
};
export const deleteBasket = (id: number) => {
  return api.remove<BasketFields, BasketExtraFields>(`baskets/${id}`);
};
